/**
 * StaffDetailWithTabs — composition root for the 11F.7 Staff detail page.
 *
 * `features/people` may not import `features/catalog` or
 * `features/attendance` (eslint feature boundary), so the subject list the
 * Subjects & Pay-rates grid needs, and the calendar/leaves tabs, are wired
 * here — same pattern as `sessionRegister.tsx` and `requestsHub.tsx`.
 */

import React, { useMemo } from 'react';
import { StaffDetail } from '@/features/people';
import { StaffAttendanceLeavesTab } from '@/features/attendance';
import { useSubjects } from '@features/catalog/api/subjects';
import { StaffCalendarTab } from '@/routes/calendarTabs';

export const StaffDetailWithTabs: React.FC = () => {
  // Only active subjects can carry a pay rate — an archived subject cannot
  // be scheduled, so offering a rate row for it would be dead input.
  const { data } = useSubjects({ status: 'active' });

  const payRateSubjects = useMemo(
    () =>
      (data?.items ?? []).map((s) => ({
        id: s.id,
        name: s.name,
      })),
    [data],
  );

  return (
    <StaffDetail
      renderAttendanceLeavesTab={(staffId) => (
        <StaffAttendanceLeavesTab staffId={staffId} />
      )}
      renderCalendarTab={(staffId) => <StaffCalendarTab staffId={staffId} />}
      payRateSubjects={payRateSubjects}
    />
  );
};

export default StaffDetailWithTabs;
